module.exports = [{
      plugin: require('../../lib.gatsby-plugin-twitter-pixel/gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('../../lib.gatsby-plugin-google-tag-manager/gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('../../lib.gatsby-plugin-hotjar/gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('../../lib.gatsby-plugin-facebook-pixel/gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('../../lib.gatsby-plugin-snapchat-pixel/gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('../../lib.gatsby-plugin-tiktok-pixel/gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('../../lib.gatsby-plugin-adjust-append-parameters/gatsby-browser.js'),
      options: {"plugins":[]},
    },{
      plugin: require('../../lib.gatsby-plugin-sentry/gatsby-browser.js'),
      options: {"plugins":[],"dsn":{"staging":"https://3ee272c4b07d47f6b3b1072a45db906a@o23827.ingest.sentry.io/5931679","production":"https://9f2acb9f7a8b43269b5f81055c3ccc68@o23827.ingest.sentry.io/5931679","development":"https://f601e6ba518846e7bda83141df5cb26b@o23827.ingest.sentry.io/5931679"}},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    }]
